import { render, staticRenderFns } from "./appAccordion.vue?vue&type=template&id=2f7c8327&"
import script from "./appAccordion.vue?vue&type=script&lang=js&"
export * from "./appAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports